import { render, staticRenderFns } from "./PathDetails.vue?vue&type=template&id=013f2d40&"
import script from "./PathDetails.vue?vue&type=script&lang=js&"
export * from "./PathDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports